import { AuthorizationServiceImpl } from "./authorization";
import { authorizationFilter } from "./authorization.filter";
import { Prerequisite, PrerequisiteLoadingService } from "../loading/prerequisite-loading-service";
import sdServicesModule from "../sdServicesModule";

sdServicesModule
  .service("authorizationService", AuthorizationServiceImpl)
  .filter("checkAccess", authorizationFilter)
  .run((prerequisiteLoadingService: PrerequisiteLoadingService, authorizationService: AuthorizationServiceImpl) => {
    prerequisiteLoadingService.registerCallbackForPrerequisite("authorizationService", (prerequisite: Prerequisite) => {
      return authorizationService.prerequisiteLoadCallback(prerequisite);
    });
  });
